export const GET_INIT_MESSAGE_DATA = 'GET_INIT_MESSAGE_DATA'
export const GET_TRANSLATIONS = 'GET_TRANSLATIONS'
export const GET_TRANSLATIONS_OK = 'GET_TRANSLATIONS_OK'
export const SET_USER = 'SET_USER'

export const GET_AVAILABLE_LANGS = 'GET_AVAILABLE_LANGS'
export const GET_AVAILABLE_LANGS_RECEIVED = 'GET_AVAILABLE_LANGS_RECEIVED'